import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import PopOutMenu from '../PopoutMenu/PopOutMenu.js';
var DatePickerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var CalendarMenu = styled(PopOutMenu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px;\n"], ["\n  padding: 10px;\n"])));
var templateObject_1, templateObject_2;
export { CalendarMenu, DatePickerWrapper };